import React, { useCallback } from "react";
import EventResults from "./EventResults";
import {
  AccountingEventsGroup,
  CanonicalBusinessEvent,
  DigitalBusinessDocument,
  DigitalCostDocument,
  DigitalPaymentDocument,
} from "../../types";
import { getEventVersion } from "../../helpers/typeChecks";
import VersionSelector from "../common/VersionSelector";

interface Props {
  eventData: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    | DigitalPaymentDocument
    )[];
  cbeData?: CanonicalBusinessEvent[];
  onVersionChange: (index: number) => void;
  initialIndex?: number;
}

function EventsVersionSelector(props: Props) {
  const { eventData, cbeData, onVersionChange, initialIndex } = props;

  const handleVersionChange = useCallback(
    (index: number) => {
      onVersionChange(index);
    },
    [onVersionChange]
  );

  const renderTabContent = useCallback(
    (
      items: (
        | AccountingEventsGroup
        | DigitalBusinessDocument
        | DigitalCostDocument
        | DigitalPaymentDocument
        )[]
    ) => {
      return <EventResults eventData={items[0]} cbeData={cbeData} />;
    },
    [cbeData]
  );

  const renderTabLabel = useCallback((version: number) => {
    return `Version ${version}`;
  }, []);

  return (
    <VersionSelector
      data={eventData}
      getVersion={getEventVersion}
      renderTabLabel={renderTabLabel}
      renderTabContent={renderTabContent}
      onVersionChange={handleVersionChange}
      initialIndex={initialIndex}
    />
  );
}

export default React.memo(EventsVersionSelector);
